module.exports = __webpack_public_path__ + "asset/image-error-icon-de0162d6ac3a73bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/notifications/component/error-notification/image/error-icon.svg
// module id = pDM8
// module chunks = 0